import { defineStore } from 'pinia'

import { actions } from './actions'
import { createInitialState } from './state'
import { getters } from './getters'

export const useAiSummarizeStore = defineStore('ai-summarize', {
  state: createInitialState,
  actions,
  getters,
})
